import React, { memo } from 'react'
import { useLocation } from 'react-router-dom'
import VerifyCodeComp from './VerifyCodeComp'
import LeftSection from '../../login/LeftSection'

function VerifyCode() {
  const location = useLocation()

  return (
    <>
      <div className={'w-screen h-screen flex'}>
        <VerifyCodeComp remaining={location?.state?.['remaining']} />
        <LeftSection />
      </div>
    </>
  )
}

export default memo(VerifyCode)
